import { apiSlice } from 'store/slices/api/api-slice';

export const importTradeDataApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        sphereActive: builder.mutation({
            query: (productId: string) => ({
                url: `/sphere/activate/` + productId,
                method: 'PATCH',
                header: {},
            }),
        }),
    }),
});

export const { useSphereActiveMutation } = importTradeDataApiSlice;
